// Facts the Terms and Privacy Policy depend on. Change them here, not in the documents.
export const LEGAL = {
    updated: 'October 25, 2026',
    operator: 'PetWise Technologies',
    jurisdiction: 'the Province of Ontario',
    seat: 'Toronto, Ontario',
    email: 'support@petwise.vet'
};
